export default __webpack_public_path__ + "static/media/treeHeatWaveBird.34583d1d.wav";